import dayjs from 'dayjs';

export class QuizTimeState {

  private _startTime: Date = new Date(0, 0, 0)

  start(time: Date) {
    this._startTime = time
  }

  currentDurationSeconds(finishTime: Date) {
    const asDayjs = dayjs(finishTime)
    let durationSeconds = asDayjs.diff(this._startTime, 'second')

    return durationSeconds
  }
}
